export default function DividerBlock({ settings }) {
  const { padding, margin } = settings

  const containerStyle = {
    padding: `${padding.top} ${padding.right} ${padding.bottom} ${padding.left}`,
    margin: `${margin.top} ${margin.right} ${margin.bottom} ${margin.left}`
  }

  const dividerStyle = {
    width: settings.width,
    height: settings.height,
    backgroundColor: settings.color,
    border: 'none',
    margin: '0 auto'
  }

  return (
    <div style={containerStyle}>
      <hr style={dividerStyle} />
    </div>
  )
}
